/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bind-project-bar.vue?vue&type=template&id=d4040c5e&"
import script from "./bind-project-bar.vue?vue&type=script&lang=ts&"
export * from "./bind-project-bar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports